/**
 * Announces messages that arrived while the reader was scrolled away, without moving the list. Floats over
 * the stream rather than sitting in the layout, so appearing never reflows what's being read.
 */
export function NewMessagesHint({ show, onClick }: { show: boolean; onClick: () => void }) {
  if (!show) return null;
  return (
    <button className="new-msgs-hint" onClick={onClick} type="button">
      ↓ New messages
    </button>
  );
}
